///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import OutlinedInput from "../form-controls/OutlinedInput";
import messages from "../../helpers/messages";
import getCurrency from "../../helpers/getCurrency";
import { mode } from "../../helpers/types";

function Financials({
  bid: { marginExpectationPercentage, annualSpend, maxCargoValue, modes },
  setBidState,
  validationData,
  removeError,
  userOrBidDivision
}) {
  const { featureFlags: { crmEnableImdlUi } } = useSelector(state => state);

  useEffect(() => {
    const hasImdlMode = modes?.some(m => m.mode === mode.imdl);
    if (crmEnableImdlUi && hasImdlMode && !marginExpectationPercentage) {
      setBidState("marginExpectationPercentage", 10);
    }
  }, [crmEnableImdlUi]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = event => {
    if (
      !event.target.validity.patternMismatch &&
      parseInt(event.target.value, 10) !== parseInt(event.target.min, 10)
    ) {
      setBidState(
        event.target.id,
        event.target.value
          ? parseInt(event.target.value, 10)
          : event.target.value
      );
    }
  };

  return (
    <div className="grid section-grid">
      <div className="grid__cell one-half">
        <OutlinedInput
          id="marginExpectationPercentage"
          value={marginExpectationPercentage}
          label={messages.marginExpectation.defaultMessage}
          pattern="[0-9]*"
          min="0"
          maxLength="2"
          unit="%"
          onChange={handleChange}
          onFocus={() =>
            !validationData.marginExpectationPercentage.isValid &&
            removeError("marginExpectationPercentage")
          }
          error={!validationData.marginExpectationPercentage.isValid}
          validationMessage={
            validationData.marginExpectationPercentage.validationMessage
          }
        />
      </div>
      <div className="grid__cell one-half">
        <OutlinedInput
          id="annualSpend"
          value={annualSpend}
          label={messages.annualSpendOptional.defaultMessage}
          pattern="[0-9]*"
          min="0"
          maxLength="9"
          unit={getCurrency(userOrBidDivision)}
          isUnitPositionLeft={true}
          onChange={handleChange}
        />
      </div>
      <div className="grid__cell one-half">
        <OutlinedInput
          id="maxCargoValue"
          value={maxCargoValue}
          label={messages.highValueOfCargoOptional.defaultMessage}
          pattern="[0-9]*"
          min="0"
          maxLength="9"
          unit={getCurrency(userOrBidDivision)}
          isUnitPositionLeft={true}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default Financials;
